<template>
  <section 
    role="content" 
    class="ff ff-ttb ff-center horizontal-padding section-padding" 
    :class="'bg-' + content.bg_color + (scrollTo ? ' has-prompt' : '')"
    :id="'content-' + (index + 1)"
  >
    <h2 class="section-heading">{{ content.heading }}</h2>
    
    <div v-for="(block, b) in content.blocks" class="content-block" :key="'block-' + index + '-' + b">
      
      <div v-if="block.type === 'text'" class="content-type-text large max-width-900">
        <p v-if="block.heading" class="large"><strong>{{ block.heading }}</strong></p>
        <div v-if="block.content" v-html="block.content"></div>
        <hr v-if="b < (content.blocks.length - 1) && !block.hide_separator" class="hr-100">
      </div>
      
      <div v-if="block.type === 'tiles'" class="content-type-tiles max-width" :class="block.custom_classes ? block.custom_classes : ''">
        <p v-if="block.heading" class="large"><strong>{{ block.heading }}</strong></p>
        <div class="ff-columns">
          <article 
            v-for="(column, c) in block.content" 
            class="ff ff-text-center animated-tile ff-12" 
            data-aos="fade-up"
            data-aos-once="true"
            data-aos-duration="250"
            :data-aos-delay="c * 100"
            :class="{
              'ff-sm-6 ff-lg-4' : (block.content.length % 3 === 0),
              'ff-sm-6 ff-lg-3' : (block.content.length % 3 !== 0 && block.content.length > 1)
            }"
            :key="'column-' + index + '-' + b + '-' + c"
          >
            
            <router-link 
              v-if="column.link" 
              :to="column.link" 
              class="bg-white ff-12 tile" 
              :class="column.custom_classes ? column.custom_classes : ''"
            >
              <div 
                v-if="column.image && column.image_style === 'full'"
                class="column-image column-image-full"
                :style="'background-image: url(' + column.image.mobile + ');'" 
              ></div>
              <div 
                v-if="column.image && (column.image_style === 'icon' || column.image_style === 'large')"
                class="column-image"
                :class="{
                  'column-image-icon' : column.image_style === 'icon',
                  'column-image-large-icon' : column.image_style === 'large'
                }"
                :style="'background-image: url(' + column.image.desktop + ');'" 
              ></div>
              <div 
                v-if="column.image && column.image_style === 'circle'"
                class="column-image column-image-circle"
                :style="'background-image: url(' + column.image.thumb + ');'" 
              ></div>
              <div class="padding min-padding" :class="column.image && column.image_style !== 'full' ? 'no-padding-top' : ''">
                <h4 v-if="column.heading" class="tile-heading" :class="{'has-subheading': column.subheading}">{{ column.heading }}</h4>
                <p v-if="column.subheading" class="tile-subheading">{{ column.subheading }}</p>
                <hr v-if="column.heading || column.subheading" class="hr-50">
                <div v-if="column.content" v-html="column.content"></div>
                <div v-if="block.include_count" class="column-counter">{{ c + 1 }}</div>
              </div>
            </router-link>
            
            <div v-else class="bg-white ff-12 tile" :class="column.custom_classes ? column.custom_classes : ''">
              <div 
                v-if="column.image && column.image_style === 'full'"
                class="column-image column-image-full"
                :style="'background-image: url(' + column.image.mobile + ');'" 
              ></div>
              <div 
                v-if="column.image && (column.image_style === 'icon' || column.image_style === 'large')"
                class="column-image"
                :class="{
                  'column-image-icon' : column.image_style === 'icon',
                  'column-image-large-icon' : column.image_style === 'large'
                }"
                :style="'background-image: url(' + column.image.desktop + ');'" 
              ></div>
              <div 
                v-if="column.image && column.image_style === 'circle'"
                class="column-image column-image-circle"
                :style="'background-image: url(' + column.image.thumb + ');'" 
              ></div>
              <div class="padding min-padding" :class="column.image && column.image_style !== 'full' ? 'no-padding-top' : ''">
                <h4 v-if="column.heading" class="tile-heading" :class="{'has-subheading': column.subheading}">{{ column.heading }}</h4>
                <p v-if="column.subheading" class="tile-subheading">{{ column.subheading }}</p>
                <hr v-if="column.heading || column.subheading" class="hr-50">
                <div v-if="column.content" v-html="column.content"></div>
                <div v-if="block.include_count" class="column-counter">{{ c + 1 }}</div>
              </div>
            </div>
            
          </article>
        </div>
        <hr v-if="b < (content.blocks.length - 1) && !block.hide_separator" class="hr-100">
      </div>
      
      <div v-if="block.type === 'columns'" class="content-type-columns max-width">
        <p v-if="block.heading" class="large"><strong>{{ block.heading }}</strong></p>
        <div 
          class="ff-columns"
          :class="block.custom_classes ? block.custom_classes : ''"
        >
          <article 
            v-for="(column, c) in block.content" 
            class="ff ff-text-center animated-column ff-12" 
            data-aos="fade"
            data-aos-once="true"
            data-aos-duration="300"
            :data-aos-delay="c * 150"
            :class="{
              'ff-sm-6 ff-lg-4' : (block.content.length % 3 === 0),
              'ff-sm-6 ff-lg-3' : (block.content.length % 3 !== 0 && block.content.length > 1)
            }"
            :key="'column-' + index + '-' + b + '-' + c"
          >
            
            <router-link 
              v-if="column.link" 
              :to="column.link" 
              class="ff-12 column" 
              :class="column.custom_classes ? column.custom_classes : ''"
            >
              <div 
                v-if="column.image && column.image_style === 'full'"
                class="column-image column-image-full"
                :style="'background-image: url(' + column.image.mobile + ');'" 
              ></div>
              <div 
                v-if="column.image && (column.image_style === 'icon' || column.image_style === 'large')"
                class="column-image"
                :class="{
                  'column-image-icon' : column.image_style === 'icon',
                  'column-image-large-icon' : column.image_style === 'large'
                }"
                :style="'background-image: url(' + column.image.desktop + ');'" 
              ></div>
              <div 
                v-if="column.image && column.image_style === 'circle'"
                class="column-image column-image-circle"
                :style="'background-image: url(' + column.image.thumb + ');'" 
              ></div>
              <div class="padding" :class="column.image && column.image_style !== 'full' ? 'no-padding-top' : ''">
                <h4 v-if="column.heading" class="column-heading">{{ column.heading }}</h4>
                <hr v-if="column.heading && column.content" class="hr-50" :class="content.bg_color === 'dark-grey' ? 'hr-grey' : ''">
                <div v-if="column.content" v-html="column.content"></div>
                <div v-if="block.include_count" class="column-counter">{{ c + 1 }}</div>
              </div>
            </router-link>
            
            <div v-else class="ff-12 column" :class="column.custom_classes ? column.custom_classes : ''">
              <div 
                v-if="column.image && column.image_style === 'full'"
                class="column-image column-image-full"
                :style="'background-image: url(' + column.image.mobile + ');'" 
              ></div>
              <div 
                v-if="column.image && (column.image_style === 'icon' || column.image_style === 'large')"
                class="column-image"
                :class="{
                  'column-image-icon' : column.image_style === 'icon',
                  'column-image-large-icon' : column.image_style === 'large'
                }"
                :style="'background-image: url(' + column.image.desktop + ');'" 
              ></div>
              <div 
                v-if="column.image && column.image_style === 'circle'"
                class="column-image column-image-circle"
                :style="'background-image: url(' + column.image.thumb + ');'" 
              ></div>
              <div class="padding" :class="column.image && column.image_style !== 'full' ? 'no-padding-top' : ''">
                <h4 v-if="column.heading">{{ column.heading }}</h4>
                <hr v-if="column.heading" class="hr-50">
                <div v-if="column.content" v-html="column.content"></div>
                <div v-if="block.include_count" class="column-counter">{{ c + 1 }}</div>
              </div>
            </div>
            
          </article>
        </div>
        <hr v-if="b < (content.blocks.length - 1) && !block.hide_separator" class="hr-100">
      </div>
      
      <div v-if="block.type === 'profile'" class="content-type-profiles max-width">
        <p v-if="block.heading" class="large"><strong>{{ block.heading }}</strong></p>
        <div class="ff-columns">
          <article 
            v-for="(profile, p) in block.content" 
            class="ff ff-text-center animated-tile" 
            data-aos="fade-up"
            data-aos-once="true"
            data-aos-duration="250"
            :data-aos-delay="p * 100"
            :class="block.content.length % 3 === 0 ? 'ff-12 ff-sm-6 ff-lg-4' : 'ff-12 ff-sm-6 ff-lg-3'"
            :key="'profile-' + index + '-' + b + '-' + p"
          >
                          
            <div class="bg-white ff-12 tile">
              <div class="column-image column-image-circle" :style="'background-image: url(' + profile.image.mobile + ');'"></div>
              <div class="padding min-padding no-padding-top">
                <h4 v-if="profile.heading" class="profile-heading tile-heading">{{ profile.heading }}</h4>
                <p v-if="profile.job_title || profile.qualifications" class="profile-position grey">
                  <span v-if="profile.job_title">{{ profile.job_title }}</span>
                  <em v-if="profile.qualifications">{{ profile.qualifications }}</em>
                </p>
                <hr v-if="profile.heading" class="hr-50">
                <div v-if="profile.content" v-html="profile.content"></div>
              </div>
            </div>
            
          </article>
        </div>
        <hr v-if="b < (content.blocks.length - 1) && !block.hide_separator" class="hr-100">
      </div>
      
      <div v-if="block.type === 'video'" class="content-type-video max-width-900">
        <p v-if="block.heading" class="large"><strong>{{ block.heading }}</strong></p>
        
        <v-video v-if="block.video_link" v-bind:videoId="block.video_link" v-bind:previewImage="block.image.tablet"></v-video>
        
        <hr v-if="b < (content.blocks.length - 1) && !block.hide_separator" class="hr-100">
      </div>
      
    </div>

    <div v-if="scrollTo" v-on:click="scrollDown(scrollTo)" class="content-prompt bg-black">
      <icon name="ui-arrow-down" color="white" size=24 /> 
    </div>
  
  </section>
</template>

<script>
  import Video from '@/components/Video.vue'
  
  export default {
    name: "Rows",
    components: {
      'v-video': Video
    },
    props: {
      content: Object,
      index: Number,
      scrollTo: String,
    },
    mounted() {
      
    },
    methods: {
      scrollDown(targetEl) {
        var borderOffset = window.innerWidth >= 768 ? window.innerWidth * 0.02 : 0;
        this.$scrollTo(targetEl, 500, {offset: -borderOffset});
      }
    }
  }
</script>